import { Box, Grid, Typography, TextField, Divider, Button, InputAdornment, IconButton } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { hallBid, floorBidPost, phoneBid, updateReserved } from "../../Model/DeclaratorModel";
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';

const RightPannel = ({ socketDeclarator, LiveData }) => {
  const [incrEment, setIncrement] = useState("");
  const [absentee, setAbsentee] = useState(0);

  const [hp, setHammer] = useState(null)
  const [startBid, setStartbid] = useState("");

  const [floorbidvalue, setFloorBidValue] = useState(0);
  const [highestBid, setHighestBid] = useState(0);
  const [reserved, setReserved] = useState(0);
  const [askingBid, setAskingBid] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  //   setFloorBidValue(value)
  // }

  const handleChangeFLoorValue = (e) => {
    setFloorBidValue(parseInt(e.target.value, 10) || 0);
  };

  const handleChangeAskingBid = (e) => {
    setFloorBidValue(parseInt(e.target.value, 10) || 0);
    setAskingBid(parseInt(e.target.value, 10) || 0);
  };

  const handleClickValue = () => {
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
  };
 
  useEffect(() => {
    if (floorbidvalue > 0) {
      socketDeclarator.emit("updateFloorValue", {
        floorValue: askingBid,
        // updatedBy: user?.email || "admin",
        timestamp: new Date().toISOString(),
      });
  
    }
  }, [floorbidvalue, socketDeclarator]);
 
  
  const handleFloorBid = () => {
    try {
      async function postFloorBid() {
        const florrData = {
          auction_id: LiveData.auction_details.auction_id,
          setId: LiveData.auction_details.id,
          lot_number: LiveData.lot.details[0].lot_number,
          amount: floorbidvalue,
        };
        const results = await floorBidPost(florrData);
          if (results.success === true) {
          socketDeclarator.emit("send_Bid_amount", { status: 1 ,florrData});
          socketDeclarator.emit("send_status", {
            message: "OPEN",
          });
        } else {
          alert(results.msg);
          // window.location.reload();
        }
      }
        postFloorBid().catch((error) => {
          console.log(error);
      });
    } catch (error) {}
  };

  const handlePhoneBid = useCallback((amount) => {
    const florrData = {
      auction_id: LiveData.auction_details.auction_id,
      setId: LiveData.auction_details.id,
      lot_number: LiveData.lot.details[0].lot_number,
      amount: amount,
    };

    try {
      async function postphoneBid() {
 
        const results = await phoneBid(florrData);
          
        if (results.success === true) {
          socketDeclarator.emit("send_Bid_amount", { status: 2, florrData });
          socketDeclarator.emit("send_status", {
            message: "OPEN",
          });

        } else if (results.success === false) {
          alert(`Error !: ${results.msg}`);
        } else {
          // alert(results.msg);
        }
      }
      postphoneBid().catch((error) => {
          console.log(error);
      });
    } catch (error) {}
  },[LiveData]);

  useEffect(() => {
    try {
      setIncrement(LiveData.increment);

      // Keep the absentee amount visible even when the first
      // live bid has the exact same amount as the absentee bid.
      // Use the configured absentee value first, then fall back
      // to the ABSENTEE BIDDER entry in bid history.
      const toNumber = (value) => {
        if (value === null || value === undefined) return 0;

        const cleaned = String(value).replace(/[^0-9.-]/g, "");
        const parsed = Number(cleaned);

        return Number.isFinite(parsed) ? parsed : 0;
      };

      const absenteeHistory =
        Array.isArray(LiveData?.bid_history)
          ? LiveData.bid_history.find(
              (bid) =>
                String(bid?.bidder_type || "")
                  .trim()
                  .toUpperCase() === "ABSENTEE BIDDER"
            )
          : null;

      const liveAbsentee =
        toNumber(LiveData?.absentee) ||
        toNumber(absenteeHistory?.hammer) ||
        toNumber(absenteeHistory?.amount) ||
        toNumber(absenteeHistory?.bid_amount) ||
        toNumber(absenteeHistory?.bidAmount) ||
        0;

      setAbsentee(liveAbsentee);
      setHammer(LiveData.lot.details[0].hp);
      setStartbid(LiveData.lot.details[0].starting_price);
      // console.log("LiveData.lot.details[0].reserve_price ",LiveData.lot.details[0].reserve_price)
      setReserved(LiveData.lot.details[0].reserve_price);
      
      setAskingBid(
        LiveData.lot.details[0].hp === 0 || LiveData.lot.details[0].hp === null
          ? parseInt(LiveData.lot.details[0].starting_price)
          : parseInt(LiveData.increment)
      );
      setFloorBidValue(
        LiveData.lot.details[0].hp === 0 || LiveData.lot.details[0].hp === null
          ? parseInt(LiveData.lot.details[0].starting_price)
          : parseInt(LiveData.increment)
      );
      const result = LiveData.bid_history.filter((x) => x.win_status === "WIN");
      setHighestBid(result[0].email);
      } catch (error) {
        // Handle error if needed
      }
  
    return () => {
      if (socketDeclarator && typeof socketDeclarator.off === "function") {
        socketDeclarator.off("send_Bid_amount");
        socketDeclarator.off("send_status");
      } else {
        console.warn("socketDeclarator is not available during cleanup.");
      }
    };
  }, [socketDeclarator, LiveData]);
  
  const handleChangeAbsentee= (e) => {
    const value = e.target.value;
    // Optional: only allow digits
    if (/^\d*$/.test(value)) {
      setAbsentee(value);
    }
  };

  const handleChangeReserved = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setReserved(value); // Only update local state, no API call
    }
  };
  

  const handleSaveAbsentee = () => {
    console.log("Saved:", reserved);
    // You can replace this with your save logic
  };

  const [isEditable, setIsEditable] = useState(false);

  const handleToggleEditable = async () => {
    if (isEditable) {
      // Save only when toggling from editable to read-only
      try {
  
        const update_reserve = {
          auction_id: LiveData.auction_details.auction_id,
          setId: LiveData.auction_details.id,
          lot_number: LiveData.lot.details[0].lot_number,
          amount: reserved,
        };
  
        const results = await updateReserved(update_reserve);
  
        if (results.success === true) {
          alert(results.msg || "Reserved Price Successfully Updated");
        } else {
          alert(results.msg || "Something went wrong while updating the reserved price.");
        }
      } catch (error) {
        console.error("Error during reserved update:", error);
        alert("An unexpected error occurred.");
      } finally {
        }
    }
    // Toggle editable state (either entering or exiting edit mode)
    setIsEditable((prev) => !prev);
  };
  

  return (
    <Box >    
        <Grid container columns={{ xs: 4, md: 12 }}>
          <Grid item xs={6}>
              <Box style={{ display: "flex", margin: 5,  }}>
                <Typography align="right" variant="h6" style={{ margin:5,fontSize:30 }}>
                  Php
                </Typography>
                <TextField
                  type="text"
                  size="large"
                  style={{width: "100%", margin:5}}
                  inputProps={{
                    style: { fontSize:30 ,padding: "5.5px 14px"},
                  }}
                  name="floorbidvalue"
                 onChange={handleChangeFLoorValue}
                  value={
                   floorbidvalue
                  }
                />
              </Box>
        </Grid>


        <Grid item xs={6}>
              <Box style={{ display: "flex",justifyContent: "space-between" }}>
                <Button
                  fullWidth
                  onClick={() =>
                    handleFloorBid()}
                  variant="contained"
                  color="primary"
                  style={{ margin: 5 ,
                    backgroundColor: "red",
                    color: "white",}}
                >
                  Floor Bid{" "}
                  <br/>
                    Php: {incrEment === "" ? 0 : parseInt(floorbidvalue).toLocaleString()}
                </Button>

                <Button
                  fullWidth   
                  style={{
                    margin: 5,
                    backgroundColor: "green",
                    color: "white",
                  }}
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    handlePhoneBid(incrEment === "" ? 0 : parseInt(incrEment))
                  }
                >
                  Phone bid{" "}
                  <br/>
                 Php: {incrEment === "" ? 0 : parseInt(floorbidvalue).toLocaleString()}
                </Button>
              </Box>
     
          </Grid>
        </Grid>

      <Divider />

     
     
     
      <Box style={{ paddingTop: 10, padding: 20 }}>
      <Box
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography variant="h6" style={{ fontWeight: "bold" }}>
        ASKING BID:
      </Typography>

      <Box sx={{ minWidth: 150, textAlign: "right" }}>
        {isEditing ? (
          <TextField
            type="number"
            size="small"
            autoFocus
            onBlur={handleBlur} // when user clicks outside, revert to text
            onChange={handleChangeAskingBid}
            value={askingBid}
            inputProps={{
              style: {
                fontSize: 24,
                fontWeight: "bold",
                textAlign: "right",
                padding: "5px 10px",
              },
            }}
          />
        ) : (
          <Typography
            variant="h5"
            onClick={handleClickValue}
            style={{
              fontWeight: "bold",
              cursor: "pointer",
              userSelect: "none",
              color: "#1976d2",
            }}
          >
            ₱ {Number(askingBid).toLocaleString()}
          </Typography>
        )}
      </Box>
    </Box>

        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6" style={{fontWeight: 'bold'}}>STARTING BID:</Typography>
          <Typography variant="h6" style={{fontWeight: 'bold'}}>
            {startBid === "" ? 0 : parseInt(startBid).toLocaleString()}
          </Typography>
        </Box>

        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6" style={{fontWeight: 'bold'}}>CURRENT BID:</Typography>

          <Typography variant="h6" style={{fontWeight: 'bold'}}>
            {hp === "" || hp === null ? 0 : parseInt(hp).toLocaleString()}
          </Typography>
        </Box>
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6" style={{fontWeight: 'bold'}}>INCREMENT:</Typography>
          <Typography variant="h6" style={{fontWeight: 'bold'}}>
            {incrEment === "" ? 0 : parseInt(incrEment).toLocaleString()}
          </Typography>
        </Box>
        
        
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h5" style={{color: '#1876d2',fontWeight: 'bold'}}>ABSENTEE BID:</Typography>
          <TextField
                value={absentee}
                onChange={handleChangeAbsentee}
                variant="outlined"
                fullWidth
                sx={{width: '50%',marginBottom:1}}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleSaveAbsentee} edge="end">
                        <SaveIcon style={{ color: '#1876d2' }} />
                      </IconButton>
                    </InputAdornment>
                  ),
                  inputProps: {
                    style: {
                      height:10,
                      color: '#1876d2',
                      fontWeight: 'bold',
                      fontSize: '1.5rem',
                      textAlign: 'right', // ✅ correctly applied
                    },
                  },
                }}
              />

          
        </Box>


        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h5" style={{color: '#db0808',fontWeight: 'bold'}}>RESERVED PRICE:</Typography>
          <TextField
            value={reserved}
            onChange={handleChangeReserved} // ✅ not onClick
            variant="outlined"
            fullWidth
            sx={{ width: '50%' }}
            InputProps={{
              readOnly: !isEditable,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleToggleEditable} edge="end">
                    {isEditable ? (
                      <SaveIcon style={{ color: '#db0808' }} />
                    ) : (
                      <EditIcon style={{ color: '#db0808' }} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
              inputProps: {
                style: {
                  height: 10,
                  color: '#db0808',
                  fontWeight: 'bold',
                  fontSize: '1.5rem',
                  textAlign: 'right',
                },
              },
            }}
          />
          
        </Box>


        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subtitle1" gutterBottom style={{fontWeight: 'bold'}}>
            HIGH BIDDER:
          </Typography>
          <Typography variant="subtitle1" gutterBottom style={{fontWeight: 'bold'}}>
            {hp === 0 || hp === null ? "" : highestBid}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default RightPannel;
